import { LoyaltyPointsReturnRefundEventSchema } from "@redotech/redo-model/customer-event/customer-event-zod-schema";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod/v4";

export const getLoyaltyRefundEventForReturn = {
  name: "getLoyaltyRefundEventForReturn" as const,
  input: z.object({ customerId: zExt.objectId(), returnId: zExt.objectId() }),
  output: z.object({ event: LoyaltyPointsReturnRefundEventSchema.nullable() }),
};
